export enum SystemFlagEnum {
  core = "CORE",
  ms = "MineSpace",
}
export enum NoDTypeDisplayEnum {
  non_substantial = "Non Substantial",
  potentially_substantial = "Potentially Substantial",
}

export enum NoDTypeSaveEnum {
  non_substantial = "non_substantial",
  potentially_substantial = "potentially_substantial",
}

export enum NoDStatusDisplayEnum {
  pending_review = "Pending Review",
  in_review = "In Review",
  information_required = "Information Required",
  self_determined_non_substantial = "Self Determined Non Substantial",
  determined_substantial = "Determined Substantial",
  determined_non_substantial = "Determined Non Substantial",
  withdrawn = "Withdrawn",
}

export enum NodStatusSaveEnum {
  pending_review = "pending_review",
  in_review = "in_review",
  information_required = "information_required",
  self_determined_non_substantial = "self_determined_non_substantial",
  determined_substantial = "determined_substantial",
  determined_non_substantial = "determined_non_substantial",
  withdrawn = "withdrawn",
}

export enum TailingsStorageFacilityTypeEnum {
  conventional = "conventional",
  dry_stacking = "dry_stacking",
  pit = "pit",
  lake = "lake",
  other = "other",
}

export enum FacilityTypeEnum {
  tailings_storage_facility = "tailings_storage_facility",
}

export enum StorageLocationEnum {
  above_ground = "above_ground",
  below_ground = "below_ground",
}

export enum ConsequenceClassificationStatusCodeEnum {
  LOW = "LOW",
  HIG = "HIG",
  VHIG = "VHIG",
  EXT = "EXT",
  NRT = "NRT",
}

export enum TSFOperatingStatusCodeEnum {
  CLO = "CLO",
  CON = "CON",
  CLT = "CLT",
  CLA = "CLA",
  CLP = "CLP",
  OPT = "OPT",
  CAM = "CAM",
}

export enum ITRBExemptionStatusCodeEnum {
  NO = "NO",
  YES = "YES",
  EXEM = "EXEM",
}

export enum PartyTypeCodeEnum {
  PER = "PER",
  ORG = "ORG",
}

export enum DamTypeEnum {
  dam = "dam",
}
export enum OperatingStatusEnum {
  construction = "construction",
  operation = "operation",
  care_and_maintenance = "care_and_maintenance",
  closure_transition = "closure_transition",
  closure_active_care = "closure_active_care",
  closure_passive_care = "closure_passive_care",
}

export enum MinePartyAppointmentTypeCodeEnum {
  AGT = "AGT",
  APP = "APP",
  BLA = "BLA",
  CCS = "CCS",
  DAM = "DAM",
  EMM = "EMM",
  EOR = "EOR",
  EVS = "EVS",
  FOP = "FOP",
  FRB = "FRB",
  HSM = "HSM",
  LDO = "LDO",
  MMG = "MMG",
  MOR = "MOR",
  MOW = "MOW",
  MRC = "MRC",
  PAY = "PAY",
  PMT = "PMT",
  SHB = "SHB",
  SVR = "SVR",
  THD = "THD",
  TQP = "TQP",
  URP = "URP",
}

export enum ActivityTypeEnum {
  mine = "mine",
  eor_expiring_60_days = "eor_expiring_60_days",
  tsf_eor_expired = "tsf_eor_expired",
  qp_expiring_60_days = "qp_expiring_60_days",
  tsf_qp_expired = "tsf_qp_expired",
  incident_report_submitted = "incident_report_submitted",
  mine_incident_created = "mine_incident_created",
  mine_incident_updated = "mine_incident_updated",
  nod_status_changed = "nod_status_changed",
  eor_created = "eor_created",
  qfp_created = "qfp_created",
  nod_submitted = "nod_submitted",
  ir_table_submitted = "ir_table_submitted",
  major_mine_app_submitted = "major_mine_app_submitted",
  major_mine_desc_submitted = "major_mine_desc_submitted",
}

export enum LOADING_STATUS {
  none,
  sent,
  success,
  error,
}

// connection to permittee wallet
export enum VC_CONNECTION_STATES {
  null = "Inactive",
  invitation = "Pending",
  request = "Pending",
  response = "Pending",
  active = "Active",
  completed = "Active",
}

// issue state of the permit digital credential
export enum VC_CRED_ISSUE_STATES {
  null = "Not Active",
  offer_sent = "Pending",
  credential_issued = "Pending",
  credential_acked = "Active",
  done = "Active", //v2_cred_exch
  credential_revoked = "Revoked",
  deleted = "Active",
  abandoned = "Error",
  issued = "credential-issued",
}

export enum PROJECT_STATUS_CODES {
  DFT = "DFT",
  WDN = "WDN",
  ASG = "ASG",
  COM = "COM",
  OHD = "OHD",
  SUB = "SUB",
  UNR = "UNR",
  CHR = "CHR",
}

export enum MAJOR_MINE_APPLICATION_AND_IRT_STATUS_CODE_CODES {
  DFT = "DFT",
  WDN = "WDN",
  COM = "COM",
  OHD = "OHD",
  SUB = "SUB",
  UNR = "UNR",
  CHR = "CHR",
}
export enum PROJECT_SUMMARY_STATUS_CODES {
  DFT = "Draft",
  WDN = "Withdrawn",
  ASG = "Assigned",
  COM = "Complete",
  OHD = "On Hold",
  SUB = "Submitted",
  UNR = "Under review",
  CHR = "Change Requested",
}

export enum MAJOR_MINE_APPLICATION_AND_IRT_STATUS_CODES {
  DFT = "Draft",
  WDN = "Withdrawn",
  COM = "Complete",
  OHD = "On Hold",
  SUB = "Submitted",
  UNR = "Under review",
  CHR = "Change Requested",
}

export enum NOW_APPLICATION_PROGRESS_STATUS_CODES {
  TECHNICAL_REVIEW = "REV",
  REFERRAL = "REF",
  CONSULTATION = "CON",
  PUBLIC_COMMENT = "PUB",
  DRAFT = "DFT"
}

export enum PROJECT_DECISION_PACKAGE_STATUS_CODES {
  CMP = "Completed",
  INP = "In Progress",
  NTS = "Not Started",
}

export enum MINE_REPORT_SUBMISSION_CODES {
  NRQ = "NRQ",
  REQ = "REQ",
  REC = "REC",
  ACC = "ACC",
  INI = "INI",
  NON = "NON",
  WTD = "WTD",
}

export enum REPORT_TYPE_CODES {
  CRR = "CRR",
  PRR = "PRR",
  TAR = "TAR",
}

export enum MINE_REPORTS_ENUM {
  PRR = "Permit Required Report",
  CRR = "Code Required Report",
}

export enum MINE_INCIDENT_DOCUMENT_TYPE_CODE {
  INM = "INM",
  FIN = "FIN",
  INI = "INI",
}

export enum REPORT_REGULATORY_AUTHORITY_CODES {
  CPO = "CPO",
  CIM = "CIM",
  BOTH = "Both",
  NONE = "Not specified",
}

export enum REPORT_REGULATORY_AUTHORITY_ENUM {
  CPO = "Chief Permitting Officer",
  CIM = "Chief Inspector of Mines",
  Both = "Both",

}

export enum MineReportType {
  "code-required-reports" = "CRR",
  "permit-required-reports" = "PRR",
  "tailings-reports" = "TAR",
}

export enum MineReportTypeUrlParam {
  "CRR" = "code-required-reports",
  "PRR" = "permit-required-reports",
  "TAR" = "tailings-reports",
}

export enum AMS_ENVIRONMENTAL_MANAGEMENT_ACT_TYPES {
  "AIR_EMISSIONS_DISCHARGE_PERMIT" = "AIR_EMISSIONS_DISCHARGE_PERMIT",
  "EFFLUENT_DISCHARGE_PERMIT" = "EFFLUENT_DISCHARGE_PERMIT",
  "REFUSE_DISCHARGE_PERMIT" = "REFUSE_DISCHARGE_PERMIT",
  "MUNICIPAL_WASTEWATER_REGULATION" = "MUNICIPAL_WASTEWATER_REGULATION",
}

export enum AMS_AUTHORIZATION_TYPES {
  "NEW" = "NEW",
  "AMENDMENT" = "AMENDMENT",
}

export enum AMS_MINES_ACT_TYPE {
  "MINES_ACT_PERMIT" = "MINES_ACT_PERMIT",
}

export enum AMS_WATER_SUSTAINABILITY_ACT_TYPES {
  "CHANGE_APPROVAL" = "CHANGE_APPROVAL",
  "USE_APPROVAL" = "USE_APPROVAL",
  "WATER_LICENCE" = "WATER_LICENCE",
}

export enum AMS_FORESTRY_ACT_TYPE {
  "OCCUPANT_CUT_LICENCE" = "OCCUPANT_CUT_LICENCE",
}

export enum AMS_FINAL_APPLICATION_DOCUMENT_TYPES {
  AID = "Application Instruction Document",
  CLF = "Clause Amendment Form",
  DFF = "Discharge Factor Form",
  IRT = "Information Requirements Table of Concordance",
  LOC = "Location Map",
  NEN = "Notification and Engagement Report",
  QPD = "Qualified Professional Declaration Form",
  SIT = "Site Plan",
  SPR = "Supporting Documents",
  TAR = "Technical Assessment Report"
};

export enum MAX_DOCUMENT_NAME_LENGTHS {
  "MAJOR_PROJECTS" = "50",
}

export enum PERMIT_CONDITION_STATUS_CODE {
  COM = "COM",
  INP = "INP",
  NST = "NST"
}

export enum NOW_APPLICATION_NATION_STATUS_CODE {
  NOS = "NOS",
  COM = "COM",
  IPG = "IPG",
  IRV = "IRV",
  OHD = "OHD",
}

export enum NOW_APPLICATION_NATION_EVENT_PARTY_OPTIONS {
  nation = "Nation",
  consultation_advisor = "Consultation Advisor",
  permitting_inspector = "Permitting Inspector",
  proponent = "Proponent",
}

export enum MinistryContactTypeCodes {
  ROE = "ROE",
  MMO = "MMO",
  CHP = "CHP",
  CHI = "CHI",
  RDC = "RDC",
  GEN = "GEN",
}

export const officeContactTypeCodes = [MinistryContactTypeCodes.ROE, MinistryContactTypeCodes.MMO];
